<!--
    * @Description: 业务咨询
    * @Date: 2023-06-28 14:44:26
    * @filePath: Do not edit
   -->
<template>
  <div class="feedback">
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-hidden="true">
      <!--       aria-labelledby="staticBackdropLabel"
      data-bs-backdrop="static" -->
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <!-- style="width: 825px" -->
        <div class="modal-content">
          <div id="my_feedback_load" style="display: none">
            <div class="modal_load_div d-flex justify-content-center align-items-center">
              <div class="spinner-border modal_load" role="status"></div>
            </div>
          </div>
          <div class="modal-header">
            <h1 class="modal-title title">{{ $t('feedback.form.title') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body modal-dialog-scrollable">
            <form class="formData" id="feedback_formData">
              <div class="form-content">
                <input type="text" id="feedback_FullName" v-model="form.FullName" name="FullName" maxlength="100"
                  :placeholder="$t('feedback.form.form_fullname')" @blur="handleOperate('feedback_FullName')"
                  @change="handleOperate('feedback_ullName')" />
              </div>
              <div class="combination">
                <div class="form-content form_input pr--15">
                  <input type="tel" id="feedback_Telephone" v-model="form.Telephone" name="Telephone" maxlength="100"
                    :placeholder="$t('feedback.form.form_telephone')" @blur="handleOperate('feedback_Telephone')"
                    @change="handleOperate('feedback_Telephone')" />
                </div>
                <div class="form-content form_input captcha pl--15">
                  <input type="email" id="feedback_EmailAddress" v-model="form.EmailAddress" name="EmailAddress"
                    maxlength="100" :placeholder="$t('feedback.form.form_emailAddress')"
                    @change="handleOperate('feedback_EmailAddress')" />
                  <div id="feedback_emailMsg" class="pop-tips">
                    *{{ $t('feedback.form.form_tip1') }}
                  </div>
                </div>
              </div>
              <div class="combination">
                <div class="form-content form_input captcha pr--15">
                  <input type="text" id="feedback_captcha" v-model="form.captcha" name="captcha"
                    :placeholder="$t('feedback.form.form_captcha')" @blur="handleOperate('feedback_captcha')"
                    @change="handleOperate('feedback_captcha')" />
                  <div id="feedback_captchaMsg" class="pop-tips">
                    *{{ $t('feedback.form.form_tip2') }}
                  </div>
                </div>
                <div class="form-content form_input pl--15">
                  <Identity v-if="codeFlag" @getIdentifyCode="getIdentifyCode" />
                </div>
              </div>
              <div class="form-content">
                <input type="text" id="feedback_CompanyName" v-model="form.CompanyName" name="CompanyName" maxlength="200"
                  :placeholder="$t('feedback.form.form_companyName')" @blur="handleOperate('feedback_CompanyName')"
                  @change="handleOperate('feedback_CompanyName')" />
                <div class="company-err"></div>
              </div>
              <div class="form-content">
                <input type="text" id="feedback_CompanyLocation" v-model="form.CompanyLocation" name="CompanyLocation"
                  maxlength="100" :placeholder="$t('feedback.form.form_companyLocation')" />
              </div>
              <div class="combination">
                <div class="form-content form_select pr--15" id="feedback_pop-home-industry">
                  <select class="pop-select-type" id="feedback_CustomerIndustry" name="CustomerIndustry"
                    style="color: rgba(9, 15, 33, 0.4)">
                    <option value disabled selected hidden>{{ $t('feedback.form.form_customerIndustry') }}</option>
                    <option value>{{ $t('feedback.form.form_choose') }}</option>
                    <option v-for="item in cusIndustryList" :key="item.AttrKey" :value="item.AttrKey">
                      {{ item.AttrValue }}
                    </option>
                  </select>
                </div>
                <div class="form-content form_select pl--15" id="feedback_pop-home-amount">
                  <select class="pop-select-type" id="feedback_CustomerBudget" name="CustomerBudget"
                    style="color: rgba(9, 15, 33, 0.4)">
                    <option value disabled selected hidden>{{ $t('feedback.form.form_customerBudget') }}</option>
                    <option value>{{ $t('feedback.form.form_choose') }}</option>
                    <option v-for="item in cusBudgetList" :key="item.AttrKey" :value="item.AttrKey">
                      {{ item.AttrValue }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-content">
                <textarea type="text" id="feedback_ConsultDetails" v-model="form.ConsultDetails" name="ConsultDetails"
                  maxlength="2000" :placeholder="$t('feedback.form.form_consultDetails')" style="resize: none"
                  @blur="handleOperate('feedback_ConsultDetails')"
                  @change="handleOperate('feedback_ConsultDetails')"></textarea>
              </div>
            </form>
          </div>
          <div class="form-content" id="feedback_pop-btn">
            <button type="button" class="form_btn" id="feedback_popBtn" @click="submitForm">
              {{ $t('feedback.form.form_btn') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 显示toast -->
    <div aria-live="polite" aria-atomic="true"
      class="d-flex justify-content-end align-items-center p-3 w-100 feedback_toast">
      <div id="my_feedback_toast" class="toast" role="alert" aria-live="assertive" aria-atomic="true"
        data-bs-delay="3000">
        <div class="d-flex">
          <div class="toast-body text_color">{{ $t('feedback.form.form_success') }}</div>
          <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Modal, Toast } from 'bootstrap'
import Identity from '@/components/elements/identity/Identity'
import { getOptions, createBus } from '@/helpers/api'

export default {
  name: 'FeedBack',
  props: {},
  components: { Identity },
  data() {
    return {
      bsModal: null,
      codeFlag: false, // 加载验证码标识
      form: {},
      isClose: '',
      saveCaptcha: '', // 图形验证码
      cusIndustryList: [], // 【所属行业】
      cusBudgetList: [], // 【预算需求】
    }
  },
  created() {
    this.getOptions('CustomerIndustry', '所属行业') // 【所属行业】
    this.getOptions('CustomerBudget', '预算需求') // 【预算需求】

  },
  mounted() {
    this.bsModal = new Modal('#exampleModal')
    const myModalEl = document.getElementById('exampleModal')
    myModalEl.addEventListener('hide.bs.modal', event => {
      this.clearData()
    })
    myModalEl.addEventListener('show.bs.modal', event => {
      this.codeFlag = true
    })
  },

  methods: {
    // 选项集
    getOptions(code) {
      getOptions(code)
        .then((res) => {
          if (res.state === 'success') {
            code === 'CustomerIndustry' ? this.cusIndustryList = res.data.rows.sort((pre, cur) => pre.Sort - cur.Sort) : this.cusBudgetList = res.data.rows
          }
        });
    },
    // 图形验证码
    getIdentifyCode(res) {
      // console.log('res===', res)
      this.saveCaptcha = res
    },
    //
    handleOperate(id) {
      let val = ''
      val = document.getElementById(id)
      if (id === 'feedback_EmailAddress') {
        // 验证邮箱格式
        let regEmail = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/
        val.value === '' ? document.getElementById('feedback_emailMsg').classList.remove('dn') : regEmail.test(val.value) === true ? document.getElementById('feedback_emailMsg').classList.remove('dn') : document.getElementById('feedback_emailMsg').classList.add('dn')
      }
      else if (id === 'feedback_captcha') {
        // 验证图形验证码与图片的内容是否一致
        if (val.value === '') {
          val.classList.add('selected')
          document.getElementById('feedback_captchaMsg').classList.remove('dn')
        } else {
          val.classList.remove('selected')
          val.value === this.saveCaptcha ? document.getElementById('feedback_captchaMsg').classList.remove('dn') : document.getElementById('feedback_captchaMsg').classList.add('dn')
        }
      }
      else {
        val.value === '' ? val.classList.add('selected') : val.classList.remove('selected')
      }
    },
    findSelectText(list, key) {
      let val = list.find(e => { return e.AttrKey === key })
      return val ? val.AttrValue : ''
    },
    // 清空数据及样式
    clearData() {
      this.codeFlag = false
      this.form = {}
      let CustomerIndustry = document.getElementById('feedback_CustomerIndustry') // 所属行业
      let CustomerBudget = document.getElementById('feedback_CustomerBudget') // 预算需求
      CustomerIndustry.value = ""
      CustomerBudget.value = ""
      document.getElementById('feedback_FullName').classList.remove('selected')
      document.getElementById('feedback_Telephone').classList.remove('selected')
      document.getElementById('feedback_emailMsg').classList.remove('dn')
      document.getElementById('feedback_captcha').classList.remove('selected')
      document.getElementById('feedback_captchaMsg').classList.remove('dn')
      document.getElementById('feedback_CompanyName').classList.remove('selected')
      document.getElementById('feedback_ConsultDetails').classList.remove('selected')
    },
    // 提交
    submitForm() {
      // console.log('this.form:::', this.form)
      let FullName = document.getElementById('feedback_FullName') // 姓名
      let Telephone = document.getElementById('feedback_Telephone') // 联系电话
      let captcha = document.getElementById('feedback_captcha') // 图形验证码
      let CompanyName = document.getElementById('feedback_CompanyName') // 公司全称
      let CustomerIndustry = document.getElementById('feedback_CustomerIndustry') // 所属行业
      let CustomerBudget = document.getElementById('feedback_CustomerBudget') // 预算需求
      let ConsultDetails = document.getElementById('feedback_ConsultDetails') // 咨询需求
      // console.log('==========:::', CustomerBudget.value, CustomerIndustry.value)
      let sign = true
      // 必填字段：姓名、联系电话、图形验证码、公司全称、咨询需求
      if (!this.form.FullName || !this.form.Telephone || !this.form.captcha || !this.form.CompanyName || !this.form.ConsultDetails) {
        sign = false
        !this.form.FullName ? FullName.classList.add('selected') : FullName.classList.remove('selected')
        !this.form.Telephone ? Telephone.classList.add('selected') : Telephone.classList.remove('selected')
        !this.form.captcha ? captcha.classList.add('selected') : captcha.classList.remove('selected')
        !this.form.CompanyName ? CompanyName.classList.add('selected') : CompanyName.classList.remove('selected')
        !this.form.ConsultDetails ? ConsultDetails.classList.add('selected') : ConsultDetails.classList.remove('selected')
      }
      // 验证邮箱格式
      let regEmail = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/
      if (this.form.EmailAddress && regEmail.test(this.form.EmailAddress) === false) {
        sign = false
        regEmail.test(this.form.EmailAddress) === true ? document.getElementById('feedback_emailMsg').classList.remove('dn') : document.getElementById('feedback_emailMsg').classList.add('dn')
      }
      // 验证图形验证码与图片的内容是否一致
      if (this.form.captcha && this.form.captcha !== this.saveCaptcha) {
        sign = false
        this.form.captcha === this.saveCaptcha ? document.getElementById('feedback_captchaMsg').classList.remove('dn') : document.getElementById('feedback_captchaMsg').classList.add('dn')
      }
      if (sign === true) {
        document.getElementById('my_feedback_load').removeAttribute("style") // 开始loading
        // 创建
        // 'ProcessStatus': 10, // 【处理状态】默认赋值为：待处理（10）
        let data = {
          'FullName': this.form.FullName ? this.form.FullName : '',
          'Telephone': this.form.Telephone ? this.form.Telephone : '',
          'CompanyName': this.form.CompanyName ? this.form.CompanyName : '',
          'CompanyLocation': this.form.CompanyLocation ? this.form.CompanyLocation : '',
          'EmailAddress': this.form.EmailAddress ? this.form.EmailAddress : '',
          'CustomerIndustry': CustomerIndustry.value ? parseInt(CustomerIndustry.value) : 0,
          'CustomerIndustryName': CustomerIndustry.value ? this.findSelectText(this.cusIndustryList, CustomerIndustry.value) : '',
          'CustomerBudget': CustomerBudget.value ? parseInt(CustomerBudget.value) : 0,
          'CustomerBudgetName': CustomerBudget.value ? this.findSelectText(this.cusBudgetList, CustomerBudget.value) : '',
          'ConsultDetails': this.form.ConsultDetails ? this.form.ConsultDetails : '',
          'ProcessStatus': 10,
          'ProcessDesc': ''
        }
        // console.log('data::', data)
        createBus(data)
          .then((res) => {
            if (res.state == "success") {
              document.getElementById('my_feedback_load').style.display = "none" // 结束loading
              // 模态框取消
              var myModal = document.getElementById('exampleModal')
              this.bsModal.hide(myModal)
              this.successToast()
              // this.clearData()
            }
          });
      }
    },
    // 提交成功提示
    successToast() {
      var toastElList = [].slice.call(document.querySelectorAll('#my_feedback_toast'))
      var toastList = toastElList.map(function (toastEl) {
        return new Toast(toastEl)
      })
      toastList.forEach(toast => toast.show())
    }
  }

}
</script>